import { cn } from '@/lib/utils.ts';
import { Search, X } from 'lucide-react';
import React, { useState } from 'react';
import { useTableStoreContext } from '@/components/table/contexts/TableContext.tsx';
import { useDebouncedCallback } from '@tanstack/react-pacer';

const SearchAction = () => {
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  const setSearchTerm = useTableStoreContext((state) => state.setSearchTerm);
  const initialTerm = useTableStoreContext((state) => state.searchTerm);

  // `useState` czyta store tylko przy pierwszym renderze — potem źródłem
  // prawdy jest pole, a nowa fraza z `?query=` przychodzi z remountem tabeli.
  const [isActive, setIsActive] = useState(initialTerm.length > 0);
  const [searchQuery, setSearchQuery] = useState(initialTerm);

  const debouncedSetSearchTerm = useDebouncedCallback(setSearchTerm, {
    wait: 300,
  });

  const clearSearchQuery = () => {
    setSearchQuery('');
    setIsActive(false);
    setSearchTerm('');
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    setIsActive(value.length > 0);
    debouncedSetSearchTerm(value);
  };

  return (
    <div
      className={cn(
        'box-border flex h-[30px] w-[200px] items-center justify-center gap-1 rounded-md border border-neutral-200 pr-0.5 transition',
        {
          'bg-neutral-100': isActive,
        },
      )}
    >
      <div
        className="flex w-full flex-row items-center gap-1 py-0.5 pl-2"
        onClick={() => inputRef?.current?.focus()}
      >
        <Search className="size-3.5 text-neutral-600" />
        <input
          ref={inputRef}
          className="w-full bg-transparent text-xs font-medium leading-[16px] text-base-text placeholder:text-neutral-300 focus:outline-none"
          placeholder={'Wyszukaj...'}
          value={searchQuery}
          onChange={handleInputChange}
          type="text"
        />
      </div>
      {isActive && (
        <button
          className="rounded-[2px] p-0.5 hover:bg-neutral-200"
          onClick={clearSearchQuery}
        >
          <X className="size-4 text-neutral-600" />
        </button>
      )}
    </div>
  );
};

export default SearchAction;
